import { type FC } from "react";
import { type PostContentBlocksType } from "~/utils/postUtils";
import Image from "next/image";
import { type Poll } from "~/lib/db/poll";
import Blocks from "../Blocks";

type SocialComponentProps = {
  block: PostContentBlocksType;
  polls: Poll[];
  idBlock: number;
  indexArticle: number;
};

const MediaTextComponent: FC<SocialComponentProps> = ({
  block,
  polls,
  idBlock,
  indexArticle,
}) => {
  const mediaPosition = block?.attrs?.mediaPosition;
  const mediaUrlImg = block?.innerHTML
    ?.match(/src=".*\.(jpg|png|jpeg|gif)"/g)[0]
    .replace(`src="`, "")
    .replace(`"`, "")
    .replace("wp-nr.", "");
  return (
    <div
      className={`wp-block-media-text ${
        mediaPosition && mediaPosition == "right"
          ? "has-media-on-the-right"
          : ""
      } is-stacked-on-mobile`}
    >
      <figure className="wp-block-media-text__media">
        <Image src={mediaUrlImg} width={800} height={600} alt={"immagine"} />
      </figure>
      <div className="wp-block-media-text__content">
        <Blocks
          blocks={block.innerBlocks}
          polls={polls}
          idBlock={idBlock}
          father={block}
          indexArticle={indexArticle}
        />
      </div>
    </div>
  );
};

export default MediaTextComponent;
